import React, { useState, useMemo } from "react";
import Accordion from "react-bootstrap/Accordion";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import "../styles/UtahVerticals.css";
import "../styles/UtahAtAGlance.css";
import "../styles/AerospaceFaqSection.css";
import { Link } from "react-router-dom";
import BetsySpeechControls from "../components/BetsySpeechControls";
import { renderToStaticMarkup } from "react-dom/server";

const faqs = [
  {
    id: "FAQ.UTDT.1",
    question: "How did the idea of building UTahData.org come to be?",
    answer: (
      <>
        <strong>UTahData.org is the brainchild of Sumit Parashar</strong>, CEO
        of BODEX and a proud Utah resident for over 27 years. With deep
        expertise in Enterprise Data Management and a passion for public impact,
        Sumit envisioned a platform that could simplify, centralize, and
        celebrate Utah’s data story. The idea was born in{" "}
        <strong>Q4 of 2024</strong>, and with the support of a talented BODEX
        team of <>data analysts</> and <>AI software engineers</>,{" "}
        <>UTahData.org</> began taking shape—driven by the goal of building a
        data portal that informs, inspires, and reflects the best of Utah.
      </>
    ),
    audioPath: "/audio/faq1.mp3",
    //  answer:
    //   "UTahData.org is the brainchild of Sumit Parashar, CEO of BODEX and a proud Utah resident for over 27 years. With deep expertise in Enterprise Data Management and a passion for public impact, Sumit envisioned a platform that could simplify, centralize, and celebrate Utah’s data story. The idea was born in Q4 of 2024, and with the support of a talented BODEX team of data analysts and AI software engineers, UTahData.org began taking shape, driven by the goal of building a data portal that informs, inspires, and reflects the best of Utah.",
  },
  {
    id: "FAQ.UTDT.2",
    question: "What is UTahData.org and why was it created?",
    answer: (
      <>
        <strong>UTahData.org</strong> is a public platform built to celebrate
        Utah’s progress through data. It serves as a{" "}
        <strong>one-stop shop</strong> for visualizing, exploring, and
        understanding open data related to Utah’s people, economy, environment,
        and more. It also showcases
        <strong>
          {" "}
          BODEX’s capabilities in AI, Data Management, and Software Development
        </strong>{" "}
        designed to make Utah look good and data even better.
      </>
    ),
    audioPath: "/audio/faq2.mp3",
  },
  {
    id: "FAQ.UTDT.3",
    question: "What is the mission of this site/web app?",
    answer: (
      <>
        Our mission is to{" "}
        <strong>
          centralize, simplify, and visualize public data about Utah, making it
          accessible, engaging, and actionable for all.
        </strong>{" "}
        By combining trusted data with intuitive design and AI-driven insights,
        we aim to support informed decisions, promote civic engagement, and
        showcase the best of Utah to the world.
      </>
    ),
    audioPath: "/audio/faq3.mp3",
  },
  {
    id: "FAQ.UTDT.4",
    question: "Who maintains UTahData.org and how is it funded?",
    answer: (
      <>
        The platform is developed and maintained by <strong>BODEX</strong>, a
        Utah-based, SBA 8(a) certified tech company. Currently self-funded as a
        community-driven initiative, it reflects our passion for open data and
        love for Utah. We welcome{" "}
        <strong>sponsorships and collaborations</strong> that share this vision.
      </>
    ),
    audioPath: "/audio/faq4.mp3",
  },
  {
    id: "FAQ.UTDT.5",
    question:
      "How is UTahData.org different from platforms like data.gov, census.gov, or Utah's open data portals?",
    answer: (
      <>
        While state and federal platforms offer massive datasets,{" "}
        <strong>UTahData.org focuses exclusively on Utah</strong>, offering
        curated, localized, and easy-to-understand dashboards. Think of it as a
        <strong> smart, user-friendly companion</strong> to government data that
        is more visual, more interactive, and built specifically for Utahns.
      </>
    ),
    audioPath: "/audio/faq5.mp3",
  },
  {
    id: "FAQ.UTDT.6",
    question: "What types of data can I explore on UTahData.org?",
    answer: (
      <>
        We cover a wide range of topics to help users make informed decisions
        and tell meaningful stories about Utah, including:
        <br />
        - Population and Demographics
        <br />
        - Education and Youth Trends
        <br />
        - Employment, Economy, and Industry
        <br />
        - Energy, Environment, and Infrastructure
        <br />
        - Public Health and Safety
        <br />
        - Hill Air Force Base
        <br />
        - Geothermal Hotspots
        <br />
        - And much more
        <br />
        New datasets are added regularly to ensure UTahData.org becomes your
        go-to portal for all Utah-related data.
      </>
    ),
    audioPath: "/audio/faq6.mp3",
  },
  {
    id: "FAQ.UTDT.7",
    question: "Can I visualize or download the data from UTahData.org?",
    answer: (
      <>
        Yes. Every dataset is visualized with{" "}
        <strong>interactive charts, graphs, and maps</strong>. Many datasets are
        also available for download or direct linking, making it easy to reuse
        and share insights.
      </>
    ),
    audioPath: "/audio/faq7.mp3",
  },
  {
    id: "FAQ.UTDT.8",
    question: "Is the data updated in real-time or periodically?",
    answer: (
      <>
        Data is updated periodically based on the update cycles of trusted
        sources such as the{" "}
        <strong>U.S. Census Bureau, BLS, and Utah state agencies</strong>. Each
        dataset includes <strong>timestamps and citations </strong> for
        transparency.
      </>
    ),
    audioPath: "/audio/faq8.mp3",
  },
  {
    id: "FAQ.UTDT.9",
    question: "Does UTahData.org use AI or machine learning to analyze data?",
    answer: (
      <>
        Yes. As an <strong>AI-first company</strong>, BODEX integrates
        intelligent tools that surface trends, detect anomalies, and generate
        predictions, turning complex data into{" "}
        <strong>actionable insights</strong> for all users, regardless of
        technical expertise.
      </>
    ),
    audioPath: "/audio/faq9.mp3",
  },
  {
    id: "FAQ.UTDT.10",
    question: "Who is the target audience for UTahData.org?",
    answer: (
      <>
        UTahData.org is built for: <br />
        - Students and Educators
        <br />
        - Policymakers and Civic Leaders
        <br />
        - Business Owners and Entrepreneurs
        <br />
        - Researchers, Nonprofits, and Journalists
        <br />
        Whether you're preparing a school project or shaping public policy, this
        platform delivers <strong>Utah-specific insights </strong>that matter.
      </>
    ),
    audioPath: "/audio/faq10.mp3",
  },
  {
    id: "FAQ.UTDT.11",
    question: "Can users suggest new datasets or request custom reports?",
    answer: (
      <>
        Yes! We welcome community input. If you'd like to suggest a new dataset,
        source, or request a <strong>custom report</strong>, email us at
        bodex@bodex.io or use the form on the site. Your feedback helps us grow
        and improve as Utah’s{" "}
        <strong>most user-responsive data platform.</strong>
      </>
    ),
    audioPath: "/audio/faq11.mp3",
  },
  {
    id: "FAQ.UTDT.12",
    question:
      "Are there opportunities for collaboration, sponsorship, or API integration?",
    answer: (
      <>
        Absolutely. UTahData.org is open to: - Government agencies seeking
        better public engagement tools - Sponsors who want to support civic data
        transparency - Developers and data teams looking to build on our data or
        APIs Let’s build together. Contact bodex@bodex.io to start a
        conversation.,
      </>
    ),
    audioPath: "/audio/faq12.mp3",
  },
  {
    id: "FAQ.UTDT.13",
    question:
      "How do you collect the data and ensure its validity and accuracy?",
    answer: (
      <>
        We source data exclusively from{" "}
        <strong>reputable, authoritative organizations</strong>, including
        federal agencies, Utah state departments, and public open-data
        repositories. Every dataset is cited, timestamped, and passes through{" "}
        <strong>quality assurance checks</strong> for accuracy and relevance.
        Our commitment is to make UTahData.org a{" "}
        <strong>reliable, transparent, and trustworthy</strong> platform you can
        count on.
      </>
    ),
    audioPath: "/audio/faq13.mp3",
  },
];
// function jsxToText(jsx) {
//   const temp = document.createElement("div");
//   const container = document.createElement("div");
//   // Render the JSX into a temporary container
//   const root = window.ReactDOM.createRoot(container);
//   root.render(jsx);
//   temp.innerHTML = container.innerHTML;
//   return temp.textContent || temp.innerText || "";
// }

function jsxToText(jsx) {
  const htmlString = renderToStaticMarkup(jsx);
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || "";
}

const FAQ = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [openItemIndex, setOpenItemIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenItemIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // Filter FAQs based on search query
  const filteredFaqs = useMemo(() => {
    if (!searchQuery.trim()) return faqs;

    const query = searchQuery.toLowerCase();
    // return faqs.filter(
    //   (faq) =>
    //     faq.question.toLowerCase().includes(query) ||
    //     faq.answer.toLowerCase().includes(query)
    // );
    return faqs.filter((faq) => {
      const question = faq.question?.toLowerCase() || "";
      const answerText =
        typeof faq.answer === "string"
          ? faq.answer.toLowerCase()
          : jsxToText(faq.answer).toLowerCase();

      return question.includes(query) || answerText.includes(query);
    });
  }, [faqs, searchQuery]);

  // Highlight matching text in FAQ items
  const highlightText = (text) => {
    if (!searchQuery.trim()) return text;

    const regex = new RegExp(`(${searchQuery})`, "gi");
    return text.split(regex).map((part, i) =>
      part.toLowerCase() === searchQuery.toLowerCase() ? (
        <mark key={i} className="bg-yellow-200">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };

  return (
    <>
      <LandingSection
        data={{
          imageName: "utahfaqbg.jpg",
          title: "Frequently Asked Questions",
        }}
      />

      <div className="">
        {/* At a Glance */}
        <div className="verticals_section">
          <div className="verticals-intro-faq flex-col md:flex-row items-center justify-center">
            <div className="verticals-intro-sec1-faq text-center">
              <h2>FAQs(13)</h2>
            </div>
            <div className="verticals-intro-sec2 text-2xl">
              <p>
                Explore answers to common questions about UTahData.org, its
                mission, and how you can use our tools and insights to discover
                Utah’s story through data. Whether you're a student,
                policymaker, or business leader, find out how this platform can
                serve you.
              </p>
              <Link to={"/about"}>
                {/* <ActionButton data="Know More About Us" /> */}
              </Link>
            </div>
          </div>
        </div>

        <div className="">
          {/* Search Field */}
          <div className="max-w-3xl mx-auto my-8 px-4">
            <h3 className="text-xl font-semibold text-center text-gray-700 mb-4">
              Search our FAQs for quick answers
            </h3>
            <div className="relative">
              <input
                type="text"
                placeholder="Search FAQs..."
                className="w-full px-6 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-200 shadow-sm"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <svg
                className="absolute right-3 top-3.5 h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            {searchQuery && (
              <p className="mt-2 text-sm text-gray-500">
                {filteredFaqs.length} results found
              </p>
            )}
          </div>

          {/* Accordian */}
          <div className="mx-auto max-w-[1700px]">
            {filteredFaqs.length > 0 ? (
              <Accordion
                flush
                activeKey={
                  openItemIndex !== null ? openItemIndex.toString() : null
                }
              >
                {filteredFaqs.map((faq, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={faq.id}
                    className="bg-transparent !border-none"
                  >
                    <Accordion.Header
                      className="custom-accordion-header d-flex justify-between align-items-center transition-colors duration-150 bg-transparent"
                      onClick={() => toggleItem(index)}
                    >
                      <span className="accordion-title flex items-center gap-2 !border-none">
                        <span className="font-bold">{index + 1}.</span>{" "}
                        {highlightText(faq.question)}
                      </span>
                      <span className="ms-auto text-2xl">
                        {openItemIndex === index ? "–" : "+"}
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="text-gray-700 whitespace-pre-line bg-transparent flex gap-2 items-center">
                      <BetsySpeechControls text={faq.audioPath} />
                      <div className="text-start">
                        {typeof faq.answer === "string"
                          ? highlightText(faq.answer)
                          : faq.answer}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            ) : (
              <div className="text-center py-8">
                <p className="text-gray-500">
                  No FAQs found matching your search.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default FAQ;
